import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Button from "../button/button";
import "./stuffed.css";
const Stuffed = () => {
  return (
    <Fragment>
      <div className="stuffed_body">
        <div className="stuffed_img">
          <img src="https://s18.picofile.com/file/8439985226/stuffed.png" />
        </div>
        <div className="stuffed_main">
          <div className="stuffed_text">عروسک های بامزه</div>
          <div className="stuffed_button">
            <Link to="/catalog">
              <Button
                background="white"
                color="black"
                heigh="50px"
                width="120px"
                radius="23px"
                boxShadow="0px 0px 13px -3px #636e72"
              >
                فروشگاه
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Stuffed;
